module.exports = __webpack_public_path__ + "img/especialista.6b97aa68.svg";